/** @file sampleHeld: a held (non-interpolated) channel such as flex parents, with the loop-wrap rule. */
import type { Key } from '@zilo/pose3d-pose/sample/channelTypes';

/**
 * Decision 9 (17.5): on the first pass the latest key at or before `frame`, else `def`; on a wrapped pass only keys
 * in `[loopStart, frame]` count, else the channel's last key (held over from the previous pass), else `def`.
 */
export function sampleHeld<T>(ch: Key<T>[], frame: number, def: T, wrapped: boolean, loopStart: number): T {
  let found: Key<T> | undefined;
  for (const key of ch) {
    if (key.frame > frame) break;
    if (!wrapped || key.frame >= loopStart) found = key;
  }
  if (found !== undefined) return found.value;
  const last = ch[ch.length - 1];
  return wrapped && last !== undefined ? last.value : def;
}
